import axios from 'axios';
import type {
  AccountingMethod,
  DepositLevel,
  TrustDepositBody,
} from '@/models/trustDepositTypes';

export default {
  async fetchAccountingMethods(): Promise<AccountingMethod[]> {
    const { data } = await axios.get<{ methods?: AccountingMethod[] }>(
      '/accounting/methods',
    );
    return data.methods ?? [];
  },

  async createDeposit(
    level: DepositLevel,
    id: string,
    body: TrustDepositBody,
  ): Promise<unknown> {
    const { data } = await axios.post(`/${level}s/${id}/deposit`, body, {
      // leanLawApi sent this on every request and the deposit endpoint has always received it.
      params: { timeOffset: new Date().getTimezoneOffset() },
    });
    return data;
  },
};
